/**
 * Detects a new Netlify deploy and reloads the app on the next route change.
 *
 * The build bakes APP_VERSION into the bundle and writes the same value to
 * /version.json (see build/build.js). Open tabs poll that file; when it
 * differs, the next navigation does a full page load instead of an in-app
 * route change, so nobody loses unsaved work mid-page.
 */

const CHECK_INTERVAL_MS = 5 * 60 * 1000

export default function installAutoReload(router) {
  const currentVersion = process.env.APP_VERSION
  if (process.env.NODE_ENV !== 'production' || !currentVersion) return

  let updateAvailable = false

  const checkForUpdate = async () => {
    if (updateAvailable) return
    try {
      const response = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' })
      if (!response.ok) return
      const data = await response.json()
      if (data.version && data.version !== currentVersion) {
        console.log('New version detected:', data.version)
        updateAvailable = true
      }
    } catch (err) {
      // Network blip or HTML fallback; try again next time
    }
  }

  router.beforeEach((to, from, next) => {
    if (updateAvailable) {
      window.location.assign(to.fullPath)
      return next(false)
    }
    next()
  })

  setInterval(checkForUpdate, CHECK_INTERVAL_MS)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') checkForUpdate()
  })
}



// WEBPACK FOOTER //
// ./src/plugins/auto-reload-utility.js